import { FC, MutableRefObject, useContext, useMemo } from "react";
import APIContext from "../../contexts/APIContext";
import MedicallyReadyToggle from "../medically-ready-toggle";
import { Typography } from "@analyticsMD/quil";
import { css } from "@emotion/css";
import { grey } from "@mui/material/colors";
import { Box } from "@analyticsMD/quil";
import moment from "moment/moment";

const styles = {
  medicallyReadyContainer: css`
    display: flex;
    width: 100%;
    justify-content: space-between;
  `,
  medicallyReady: css`
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
};

const sxStyles = {
  header: {
    marginLeft: "0.9rem",
    fontSize: "0.8rem",
  },
  timestamp: {
    fontSize: "0.8rem",
    marginRight: "0.5rem",
    color: grey[600],
  },
};

interface MedicallyReadySectionProps {
  updateRef?: MutableRefObject<Record<string, any>>;
  useSidebarView?: boolean;
}

const MedicallyReadySection: FC<MedicallyReadySectionProps> = ({
  updateRef,
  useSidebarView = false,
}) => {
  const {
    medicallyReadyStatusQuery,
    patientID,
    setShowErrorToast,
    configurationQuery,
    isViewOnly,
  } = useContext(APIContext);

  const medicallyReadyStatus = medicallyReadyStatusQuery.isSuccess
    ? medicallyReadyStatusQuery.data
    : null;

  const configuration = configurationQuery?.data
    ? configurationQuery?.data?.[0]
    : {};

  const medicallyReadyStatusTimestamp = useMemo(() => {
    if (!medicallyReadyStatus?.qv_updated_ts) return null;
    const momentTime = moment(medicallyReadyStatus.qv_updated_ts);
    return momentTime.fromNow();
  }, [medicallyReadyStatus?.qv_updated_ts]);

  return (
    <Box className={styles.medicallyReadyContainer}>
      <Typography
        sx={{
          ...sxStyles.header,
          marginLeft: "0.35rem",
          textWrap: "nowrap",
          display: "flex",
          alignItems: "center",
          fontSize: "0.9rem",
        }}
      >
        Medically ready:
      </Typography>
      <Box className={styles.medicallyReady}>
        {medicallyReadyStatus && (
          <Typography sx={sxStyles.timestamp}>
            {medicallyReadyStatusTimestamp}
          </Typography>
        )}
        <MedicallyReadyToggle
          medicallyReadyStatus={medicallyReadyStatus}
          patientID={patientID}
          disabled={isViewOnly || configuration.medically_ready_read_only}
          setShowErrorToast={setShowErrorToast}
          updateRef={updateRef}
          useSidebarView={useSidebarView}
        />
      </Box>
    </Box>
  );
};

export default MedicallyReadySection;
